
// import LimitedTenderCards from './LimitedTenderCards';
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { API_BASE_URL } from '../../Api/config';
// import axios from 'axios';

// const LimitedTenderView = () => {
//   const location = useLocation();

//   const [searchInput, setSearchInput] = useState('');
//   const [totalTender, setTotalTender] = useState(null)
  

//   useEffect(() => {
//     // Pre-fill the search input if available in `location.state`
//     if (location.state) {
//       const {
//         searchTerm = '',
//         categoryName = '',
//         SubDepartmentName = '',
//         districtName = '',
//         UpazilaName = '',
//         sourceName = '',
//         tender_id = '',
//       } = location.state;

//       // Combine all pre-filled values into one string
//       setSearchInput(
//         [
//           searchTerm,
//           categoryName,
//           SubDepartmentName,
//           districtName,
//           UpazilaName,
//           sourceName,
//           tender_id,
//         ]
//           .filter(Boolean)
//           .join(' ')
//       );
//     }
//   }, [location.state]);

//   // Handle input change with an instant effect
//   const handleInputChange = e => {
//     const value = e.target.value;
//     setSearchInput(value);

//     // Ensure instant update by passing the cleared state to the child
//     if (value.trim() === '') {
//       triggerReset(); // Trigger reset to show all tenders
//     }
//   };

//   const triggerReset = () => {
//     // Logic to clear filters and fetch all tenders instantly
//     setSearchInput(''); // Ensure input is cleared
//   };

//   useEffect(() => {
//     const fetchSectorData = async () => {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/user/visitor/sector`);
//         console.log('Sector Data:', response.data);
//         setTotalTender(response.data.total)
//       } catch (error) {
//         console.error('Error fetching sector data:', error);
//       }
//     };

//     fetchSectorData();
//   }, []); 
 
 
 




//   return (
//     <div className="bg-white h-auto container mx-auto">
//       <div className="flex flex-col md:flex-row mt-24 lg:mt-32 md:py-10 py-4">
//         <div className="w-full md:p-4 p-2 md:-mt-4">
//           {/* Search Input Section */}
//           <div className="md:p-4 p-2 rounded-md mb-4 border">
//             <div>
//               <h3 className="md:text-lg text-sm font-semibold mb-2 ml-2">All Tenders: {totalTender}</h3>
  

              
//             </div>
//             <div className="w-full relative">
//               <input
//                 id="searchInput"
//                 type="text"
//                 value={searchInput}
//                 onChange={handleInputChange}
//                 placeholder="Search by keyword, category, department, district, etc."
//                 className="px-4 py-2 rounded-md border-2 focus:ring-2 focus:ring-BrowsBg focus:outline-none text-sm text-gray-700 w-full"
//               />
//             </div>
//           </div>

//           {/* Search Result Section */}
//           <div className="md:p-2 rounded-md border">
//             {/* <LimitedTenderCards searchQuery={searchInput} /> */}
//             <LimitedTenderCards searchQuery={searchInput} totalTender={totalTender} />

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LimitedTenderView;





import LimitedTenderCards from './LimitedTenderCards';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../../Api/config';
import axios from 'axios';

const LimitedTenderView = () => {
  const location = useLocation();
  const [searchInput, setSearchInput] = useState('');
  const [totalTender, setTotalTender] = useState(null);

  useEffect(() => {
    // Pre-fill the search input if available in location.state
    if (location.state) {
      const {
        searchTerm = '',
        categoryName = '',
        SubDepartmentName = '',
        districtName = '',
        UpazilaName = '',
        sourceName = '',
        tender_id = '',
      } = location.state;

      // Combine all pre-filled values into one string
      setSearchInput(
        [
          searchTerm,
          categoryName,
          SubDepartmentName,
          districtName,
          UpazilaName,
          sourceName,
          tender_id,
        ]
          .filter(Boolean)
          .join(' ')
      );
    }
  }, [location.state]);

  // Handle input change with an instant effect
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    // Ensure instant update by passing the cleared state to the child
    if (value.trim() === '') {
      triggerReset(); // Trigger reset to show all tenders
    }
  };

  const triggerReset = () => {
    // Logic to clear filters and fetch all tenders instantly
    setSearchInput(''); // Ensure input is cleared
  };

  // Fetch total tenders from the same API endpoint used in LimitedTenderCards
  useEffect(() => {
    const fetchTotalTenders = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/user/visitor`, {
          params: {
            key: '', // Fetch all tenders initially
          },
        });
        setTotalTender(response.data?.total || 0);
      } catch (error) {
        console.error('Error fetching total tenders:', error);
      }
    };

    fetchTotalTenders();
  }, []);

  return (
    <div className="bg-white h-auto container mx-auto">
      <div className="flex flex-col md:flex-row mt-24 lg:mt-32 md:py-10 py-4">
        <div className="w-full md:p-4 p-2 md:-mt-4">
          {/* Search Input Section */}
          <div className="md:p-4 p-2 rounded-md mb-4 border">
            <div>
              <h3 className="md:text-lg text-sm font-semibold mb-2 ml-2">
                All Tenders: {totalTender || 'Loading...'}
              </h3>
            </div>
            <div className="w-full relative">
              <input
                id="searchInput"
                type="text"
                value={searchInput}
                onChange={handleInputChange}
                placeholder="Search by keyword, category, department, district, etc."
                className="px-4 py-2 rounded-md border-2 focus:ring-2 focus:ring-BrowsBg focus:outline-none text-sm text-gray-700 w-full"
              />
            </div>
          </div>

          {/* Search Result Section */}
          <div className="md:p-2 rounded-md border">
            <LimitedTenderCards
              searchQuery={searchInput}
              setTotalTender={setTotalTender} // Pass the setter to update totalTender
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitedTenderView;



